import DOMPurify from 'dompurify';

/**
 * Allow only safe URL schemes in href attributes.
 * @param {string} url
 * @returns {string|null}
 */
export function sanitizeUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  try {
    const parsed = new URL(trimmed, 'https://example.com');
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return trimmed.startsWith('http') ? trimmed : parsed.href.replace('https://example.com', '');
    }
  } catch {
    return null;
  }
  return null;
}

/**
 * Sanitize HTML before rendering user-authored content.
 * @param {string} html
 * @returns {string}
 */
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || '', {
    USE_PROFILES: { html: true }
  });
}
